import cx from 'classnames';
import { Line } from '@visx/shape';
import { Text } from '@visx/text';
import getLabelTransform from "../utils/getLabelTransform.js";
import Orientation from "../constants/orientation.js";
import Ticks from "./Ticks.js";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const defaultTextProps = {
  textAnchor: 'middle',
  fontFamily: 'Arial',
  fontSize: 10,
  fill: '#222'
};
export default function AxisRenderer(_ref) {
  let {
    axisFromPoint,
    axisLineClassName,
    axisToPoint,
    hideAxisLine,
    hideTicks,
    horizontal,
    label = '',
    labelClassName,
    labelOffset = 14,
    labelProps,
    orientation = Orientation.bottom,
    scale,
    stroke = '#222',
    strokeDasharray,
    strokeWidth = 1,
    tickClassName,
    tickComponent,
    tickLineProps,
    tickLabelProps,
    tickLength = 8,
    tickStroke = '#222',
    tickTransform,
    ticks,
    ticksComponent = Ticks
  } = _ref;
  const combinedLabelProps = {
    ...defaultTextProps,
    ...labelProps
  };
  const tickLabelPropsDefault = {
    ...defaultTextProps,
    ...(typeof tickLabelProps === 'object' ? tickLabelProps : null)
  };
  // compute the max tick label size to compute label offset
  const allTickLabelProps = ticks.map(_ref2 => {
    let {
      value,
      index
    } = _ref2;
    return typeof tickLabelProps === 'function' ? tickLabelProps(value, index, ticks) : tickLabelPropsDefault;
  });
  const maxTickLabelFontSize = Math.max(10, ...allTickLabelProps.map(props => typeof props.fontSize === 'number' ? props.fontSize : 0));
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [ticksComponent({
      hideTicks,
      horizontal,
      orientation,
      scale,
      tickClassName,
      tickComponent,
      tickLabelProps: allTickLabelProps,
      tickStroke,
      tickTransform,
      ticks,
      strokeWidth,
      tickLineProps
    }), !hideAxisLine && /*#__PURE__*/_jsx(Line, {
      className: cx('visx-axis-line', axisLineClassName),
      from: axisFromPoint,
      to: axisToPoint,
      stroke: stroke,
      strokeWidth: strokeWidth,
      strokeDasharray: strokeDasharray
    }), label && /*#__PURE__*/_jsx(Text, {
      className: cx('visx-axis-label', labelClassName),
      ...getLabelTransform({
        labelOffset,
        labelProps: combinedLabelProps,
        orientation,
        range: scale.range(),
        tickLabelFontSize: maxTickLabelFontSize,
        tickLength
      }),
      ...combinedLabelProps,
      children: label
    })]
  });
}